import {
  docIcon,
  heartIcon,
  quoteIcon,
  stockIcon,
  storeIcon,
} from "../icon_assets";
export const optionsData = [
  {
    icon: docIcon,
    text: "Documents",
  },
  {
    icon: stockIcon,
    text: "Stock Log",
  },
  {
    icon: heartIcon,
    text: "Wishlist",
  },

  {
    icon: storeIcon,
    text: "My Store",
  },
  {
    icon: heartIcon,
    text: "Wishlist",
  },
  {
    icon: quoteIcon,
    text: "My Quotes",
  },

  {
    icon: storeIcon,
    text: "A/C Statement",
  },
];
